var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbbLogo655X358Px01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 655 358",
    style: {
      enableBackground: "new 0 0 655 358"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#XMLID_2_);}\r\n\t.st1{fill:url(#XMLID_3_);}\r\n\t.st2{fill:url(#XMLID_4_);}\r\n\t.st3{fill:url(#XMLID_5_);}\r\n\t.st4{fill:url(#XMLID_7_);}\r\n\t.st5{fill:url(#XMLID_8_);}\r\n\t.st6{fill:url(#XMLID_9_);}\r\n\t.st7{fill:url(#XMLID_10_);}\r\n\t.st8{fill:url(#XMLID_11_);}\r\n\t.st9{fill:url(#XMLID_13_);}\r\n\t.st10{fill:url(#XMLID_27_);}\r\n\t.st11{fill:url(#XMLID_28_);}\r\n\t.st12{fill:url(#XMLID_29_);}\r\n\t.st13{fill:url(#XMLID_30_);}\r\n\t.st14{fill:url(#XMLID_31_);}\r\n\t.st15{fill:url(#XMLID_32_);}\r\n\t.st16{fill:url(#XMLID_33_);}\r\n\t.st17{fill:url(#XMLID_34_);}\r\n\t.st18{fill:url(#XMLID_35_);}\r\n\t.st19{fill:url(#XMLID_85_);}\r\n\t.st20{fill:url(#XMLID_86_);}\r\n\t.st21{fill:url(#XMLID_87_);}\r\n\t.st22{fill:url(#XMLID_88_);}\r\n\t.st23{fill:url(#XMLID_89_);}\r\n\t.st24{fill:#4792CE;}\r\n\t.st25{fill:url(#XMLID_90_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.9925,
    y1: 119.1342,
    x2: 335.1626,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M300.99,97h18.81c12.74,0,15.36,11.35,15.36,22.32c0,13.03-4.55,21.95-15.36,21.95h-18.81V97z  M319.14,133.72c5.49,0,7.56-5.58,7.56-14.46c0-11.84-2.84-14.79-7.56-14.79h-9.68v29.25H319.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.655,
    y1: 119.2329,
    x2: 368.7477,
    y2: 119.2329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st1",
    d: "M339.66,106.19c0-7.68,5.44-9.27,9.62-9.19c0,0,15.59,0.44,19.48,0.97v7h-17.48 c-3.15,0-3.15,1.75-3.15,3.39v6.91L366,115.9v6.96l-17.87,0.57v6.91c0.03,3.21,2,3.14,3.75,3.14h16.88v6.94 c-3.43,0.47-18.87,1.03-18.87,1.03c-3.95,0.18-10.22-0.72-10.22-8.88V106.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.113,
    y1: 119.1342,
    x2: 401.5096,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st2",
    d: "M374.11,97h8.47v33.32c0,3.21,2,3.14,3.75,3.14h15.18v7.8h-18.17c-4.82,0-9.22-1.78-9.22-8.62 V97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.7115,
    y1: 119.1342,
    x2: 415.1783,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st3",
    d: "M406.71,97h8.47v44.27h-8.47V97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.9115,
    y1: 119.1342,
    x2: 458.1938,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st4",
    d: "M428.9,97l9.85,33.14L449.2,97h8.99l-14.61,44.27h-9.8L419.91,97H428.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.3734,
    y1: 119.2329,
    x2: 489.466,
    y2: 119.2329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st5",
    d: "M460.37,106.19c0-7.68,5.44-9.27,9.62-9.19c0,0,15.59,0.44,19.48,0.97v7h-17.48 c-3.15,0-3.15,1.75-3.15,3.39v6.91l17.87,0.64v6.96l-17.87,0.57v6.91c0.03,3.21,2,3.14,3.75,3.14h16.88v6.94 c-3.43,0.47-18.87,1.03-18.87,1.03c-3.95,0.18-10.22-0.72-10.22-8.88V106.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.2541,
    y1: 119.1342,
    x2: 527.0059,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st6",
    d: "M494.25,97h19.37c6.91,0,12.05,3.23,12.05,13.8c0,10.96-4.59,12.26-7.05,13.03l8.38,17.43 h-9.53l-7.32-16.75l-7.44-0.85v17.6h-8.47V97z M512.79,117.02c2.95,0,4.35-0.86,4.35-6.21c0-5.03-1.69-6.27-4.35-6.27h-10.04 v12.49H512.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.5067,
    y1: 119.1342,
    x2: 564.035,
    y2: 119.1342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st7",
    d: "M536.73,97l8.64,21.23L554.81,97h9.22l-14.57,30.54v13.73H541v-13.73L527.51,97H536.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.9925,
    y1: 175.4378,
    x2: 332.441,
    y2: 175.4378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st8",
    d: "M300.99,153.3h18.25c9.16,0,12.49,5.47,12.49,11.82c0,4.08-1.74,8.67-6.06,9.46 c3.69,0.67,6.77,4.35,6.77,9.98c0,8.23-3.72,13-13.03,13h-18.42V153.3z M318.75,170.84c3.04,0,4.65-1.85,4.65-5.02 c0-4.1-2.51-5.05-4.65-5.05h-9.26v10.07H318.75z M319.08,190.1c2.57,0,4.9-1.22,4.9-5.92c0-3.24-1.31-6.21-4.9-6.21h-9.59v12.13 H319.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.3558,
    y1: 175.5365,
    x2: 366.4488,
    y2: 175.5365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st9",
    d: "M337.36,162.5c0-7.68,5.44-9.27,9.62-9.19c0,0,15.59,0.44,19.48,0.97v7h-17.48 c-3.14,0-3.14,1.75-3.14,3.39v6.91l17.87,0.64v6.96l-17.87,0.57v6.91c0.03,3.21,2,3.14,3.75,3.14h16.88v6.94 c-3.43,0.47-18.87,1.03-18.87,1.03c-3.95,0.18-10.22-0.72-10.22-8.88V162.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.1964,
    y1: 175.4378,
    x2: 406.7248,
    y2: 175.4378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st10",
    d: "M379.42,153.3l8.64,21.23l9.45-21.23h9.22l-14.57,30.54v13.73h-8.47v-13.73L370.2,153.3 H379.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.8845,
    y1: 175.4075,
    x2: 442.4455,
    y2: 175.4075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st11",
    d: "M424.69,153c10.46,0,17.75,2,17.75,22.74c0,19.53-6.87,22.07-17.75,22.07 s-17.81-1.94-17.81-22.07C406.88,155,414.53,153,424.69,153z M424.69,190.01c7.11,0,9.29-2.34,9.29-14.27 c0-13.79-2.56-14.94-9.29-14.94c-6.55,0-9.34,0.85-9.34,14.94C415.35,187.82,417.13,190.01,424.69,190.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.141,
    y1: 175.4378,
    x2: 482.7616,
    y2: 175.4378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st12",
    d: "M448.14,153.3h8.59l17.57,28.61V153.3h8.47v44.27h-8.47l-17.63-28.27v28.27h-8.53V153.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.1466,
    y1: 175.4378,
    x2: 523.3167,
    y2: 175.4378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st13",
    d: "M489.15,153.3h18.81c12.74,0,15.36,11.35,15.36,22.32c0,13.03-4.55,21.95-15.36,21.95h-18.81 V153.3z M507.29,190.02c5.49,0,7.56-5.58,7.56-14.46c0-11.84-2.84-14.79-7.56-14.79h-9.68v29.25H507.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.9925,
    y1: 231.7418,
    x2: 332.441,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st14",
    d: "M300.99,209.61h18.25c9.16,0,12.49,5.47,12.49,11.82c0,4.08-1.74,8.67-6.06,9.46 c3.69,0.67,6.77,4.35,6.77,9.98c0,8.23-3.72,13-13.03,13h-18.42V209.61z M318.75,227.15c3.04,0,4.65-1.85,4.65-5.02 c0-4.1-2.51-5.05-4.65-5.05h-9.26v10.07H318.75z M319.08,246.41c2.57,0,4.9-1.22,4.9-5.92c0-3.24-1.31-6.21-4.9-6.21h-9.59v12.13 H319.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.848,
    y1: 231.7115,
    x2: 372.409,
    y2: 231.7115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st15",
    d: "M354.66,209.3c10.46,0,17.75,2,17.75,22.74c0,19.53-6.87,22.07-17.75,22.07 c-10.89,0-17.81-1.94-17.81-22.07C336.85,211.3,344.5,209.3,354.66,209.3z M354.66,246.32c7.11,0,9.29-2.34,9.29-14.27 c0-13.79-2.56-14.94-9.29-14.94c-6.55,0-9.34,0.85-9.34,14.94C345.31,244.13,347.1,246.32,354.66,246.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.1044,
    y1: 231.8935,
    x2: 411.9115,
    y2: 231.8935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st16",
    d: "M378.1,209.61h8.47v24.92c0,10.12,2.24,11.85,8.59,11.85c5.65,0,8.23-2.08,8.23-11.85v-24.92 h8.53v24.92c0,19.53-9.43,19.66-16.75,19.66c-8.23,0-17.05,0.48-17.05-19.66V209.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.2632,
    y1: 231.7418,
    x2: 452.8839,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st17",
    d: "M418.26,209.61h8.59l17.57,28.61v-28.61h8.47v44.27h-8.47l-17.63-28.27v28.27h-8.53V209.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.2689,
    y1: 231.7418,
    x2: 493.439,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st18",
    d: "M459.27,209.61h18.81c12.74,0,15.36,11.35,15.36,22.32c0,13.03-4.55,21.95-15.36,21.95 h-18.81V209.61z M477.42,246.33c5.49,0,7.56-5.58,7.56-14.46c0-11.84-2.84-14.79-7.56-14.79h-9.68v29.25H477.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.967,
    y1: 231.7418,
    x2: 533.9151,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st19",
    d: "M509.91,209.61h9.63l14.38,44.27h-9.01l-3.14-9.81h-14.5l-3.19,9.81h-9.1L509.91,209.61z  M519.75,236.57l-4.97-15.8l-5.32,15.8H519.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.8593,
    y1: 231.7418,
    x2: 570.6112,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st20",
    d: "M537.86,209.61h19.37c6.91,0,12.05,3.23,12.05,13.8c0,10.96-4.59,12.26-7.05,13.03 l8.38,17.43h-9.53l-7.32-16.75l-7.44-0.85v17.6h-8.47V209.61z M556.4,229.62c2.95,0,4.35-0.86,4.35-6.21 c0-5.03-1.69-6.27-4.35-6.27h-10.04v12.49H556.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 575.1487,
    y1: 231.7418,
    x2: 583.6157,
    y2: 231.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st21",
    d: "M575.15,209.61h8.47v44.27h-8.47V209.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.8,
    y1: 231.8405,
    x2: 618.8926,
    y2: 231.8405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    className: "st22",
    d: "M589.8,218.8c0-7.68,5.44-9.27,9.62-9.19c0,0,15.59,0.44,19.48,0.97v7h-17.48 c-3.15,0-3.15,1.75-3.15,3.39v6.91l17.87,0.64v6.96l-17.87,0.57v6.91c0.03,3.21,2,3.14,3.75,3.14h16.88v6.94 c-3.43,0.47-18.87,1.03-18.87,1.03c-3.95,0.18-10.22-0.72-10.22-8.88V218.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 623.5839,
    y1: 231.7954,
    x2: 654.2794,
    y2: 231.7954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4591"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st23",
    d: "M623.58,220.67c0-8.77,5.2-11.33,11.97-11.43c6.37-0.13,13.62,0.72,17.12,1.75v6.66 c-3.87-0.34-12.59-0.6-14.79-0.6c-3.7-0.08-5.84,0.18-5.84,4.29v2.16c0,3.51,1.34,4.26,4.77,4.26h6.99 c8.68,0,10.47,6.84,10.47,11.73v2.95c0,10.05-6.26,11.91-12.25,11.91c-7.55,0-12.5-0.46-17.08-1.81v-6.66 c2.42,0.24,9.79,0.67,15.42,0.67c2.55,0,5.45-0.42,5.45-3.81v-2.38c0-2.52-0.76-4.13-3.99-4.13h-6.8 c-10.67,0-11.43-7.88-11.43-11.73V220.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st24",
    d: "M0,76.68c0.95,0,1.75,0,2.55,0c10.51,0,21.01,0,31.52,0c31.07,0,99.78-0.02,130.85,0.02 c9.74,0.01,19.26,1.45,28.25,5.42c15.22,6.71,25.24,18.19,30.74,33.77c2.76,7.83,3.7,15.93,3.06,24.15 c-0.48,6.18-2,12.15-5.63,17.36c-0.46,0.66-0.98,1.29-1.6,2.09c-0.48-0.76-0.87-1.36-1.24-1.97 c-6.92-11.24-16.87-18.19-29.77-20.84c-2.6-0.53-5.32-0.68-7.99-0.69c-11.1-0.08-22.21-0.04-33.31-0.04 c-10.27-0.01-58.19,0.02-68.46-0.03c-7.22-0.03-14.46,0.05-21.67-0.3c-13.66-0.68-25.8-5.39-36.09-14.52 C11.04,112.06,4.68,100.75,1.4,87.64C0.52,84.12,0.16,80.52,0,76.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.915,
    y1: 183.1704,
    x2: 275.8356,
    y2: 183.1704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    style: {
      stopColor: "#42418E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st25",
    d: "M275.47,170.55c-0.1-5.89-1.39-11.59-2.62-17.3c-0.51-2.37-1.34-4.67-2.07-6.99 c-0.73-2.33-1.38-4.71-2.29-6.97c-9.46-23.35-25.33-41.02-47.36-53.19c-0.67-0.37-1.39-0.66-2.31-1.09 c2.59,3.06,5.09,5.8,7.36,8.72c11.45,14.76,17.08,31.59,17.42,50.19c0.11,6.17-0.59,12.3-1.64,18.4 c-1.54,8.89-4.12,17.43-8.17,25.5c-6.34,12.64-15.43,22.68-28.1,29.23c-8.43,4.36-17.38,6.68-26.93,6.66 c-18.7-0.04-58.36-0.04-58.36-0.04l22.81-64.19H83.94l0,0c-18.33,0-34.29,0-43.96,0c-10.51,0-21.01,0-31.52,0c-0.8,0-1.6,0-2.55,0 c0.16,3.84,0.52,7.44,1.4,10.96c3.28,13.11,9.65,24.42,19.82,33.43c10.29,9.12,22.43,13.84,36.09,14.52 c0.12,0.01,0.25,0.01,0.37,0.02c-10.47,30.33-21.16,61.33-21.67,62.92c1.09,0,91.5,0.02,135.83-0.01c3.27,0,6.56-0.15,9.8-0.5 c5.89-0.63,11.75-1.55,17.49-3.07c18.27-4.83,33.91-13.93,46.32-28.36c6.59-7.67,11.69-16.21,15.6-25.52 c6.02-14.35,8.5-29.39,8.87-44.85C275.89,176.2,275.52,173.38,275.47,170.55z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbbLogo655X358Px01);
export default __webpack_public_path__ + "static/media/DBB Logo (655x358 px)-01.9816926b0a3492ca32acb7c4835cc895.svg";
export { ForwardRef as ReactComponent };